import useProjectsApi from '../projectsApi';

export type ProjectPlan = {
  id: number
  name: string
  sourcePlanId: number
}

export interface ProjectPlanService {
  getPlanByProjectId: (projectId: number) => Promise<ProjectPlan>;
}

export default function useProjectPlanService() {
  const projectsApi = useProjectsApi();

  const getPlanByProjectId = async (projectId: number) => {
    return projectsApi.get(`/projects/${projectId}/plan`);
  };

  return {
    getPlanByProjectId,
  };
}
